import { createContext, useEffect, ReactNode } from "react";
import { useTheme } from "../hooks/useTheme";
import { ThemeNames } from "@/config/theme";

interface ThemeContextType {
  currentTheme: ThemeNames;
}

const ThemeContext = createContext<ThemeContextType>({
  currentTheme: "default",
});

export function ThemeProvider({ children }: { children: ReactNode }) {
  const themeKey = (import.meta.env.VITE_THEME_NAME || "default") as ThemeNames;
  const themeColors = useTheme(themeKey);

  useEffect(() => {
    try {
      const root = document.documentElement;

      // Apply all theme colors
      Object.entries(themeColors).forEach(([key, color]) => {
        root.style.setProperty(`--${key}`, color.hsl);
      });
    } catch (error) {
      console.error("Failed to apply theme:", error);
      // Fallback to default theme or show error UI
    }
  }, [themeColors]);

  return (
    <ThemeContext.Provider value={{ currentTheme: themeKey }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Optional: Hook to access theme in components
// export function useThemeContext() {
//   const context = useContext(ThemeContext);
//   if (!context) {
//     throw new Error("useThemeContext must be used within ThemeProvider");
//   }
//   return context;
// }
